<template>
    <div class="infor fl">
        <all-header
            :label="lable"
            :ischage="ischage"
            :sublabel="sublabel"
            :subtitle="subtitle"
            @getvalue="getvalue"></all-header>
        
        <div>
                <el-select v-model="project_batch_id"
                       placeholder="请选择批次"
                       class="award_batch"
                       @change="serch">
                <el-option v-for="(bitem,bindex) in project_batches" :label="bitem['year']" :value="bitem['id']"></el-option>
            </el-select>
            <div class="right_serch">
                <input id="" v-model="keyword" type="text" name="" placeholder="输入关键词搜索..." @keyup.enter="serch">
                <img src="../assets/serch.png" alt="" @click="serch">
            </div>
            <el-tabs
                v-model="activeName"
                style="margin-top: 16px"
                tab-position="top"
                @tab-click="handleClick">
                <el-tab-pane label="待审核" name="first">
                    <el-form ref="ruleForm">
                        <el-table
                            v-loading="loading"
                            :data="formlist"
                            :header-cell-style="{ background: '#FEF8EF', color: '#7C828A' }"
                            style="width: 100%; margin-top: 30px">
                            <el-table-column
                                prop="id"
                                label="编号"
                                min-width="60"></el-table-column>
                        <el-table-column show-overflow-tooltip
                                             prop="batch"
                                             label="批次"
                                             min-width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip
                                             prop="name"
                                             label="姓名"
                                             min-width="100"></el-table-column>
                    
                            <el-table-column show-overflow-tooltip
                                             prop="major_type"
                                             label="工程类别"></el-table-column>
                            <!--<el-table-column show-overflow-tooltip-->
                            <!--                 prop="application_major"-->
                            <!--                 label="申报专业"></el-table-column>-->
                            <!--<el-table-column show-overflow-tooltip-->
                            <!--                 prop="work_jobs"-->
                            <!--                 label="工作范围"  min-width="140"></el-table-column>-->
                                                                              
                            <el-table-column
                                prop="created_at"
                                label="申报时间"
                                min-width="80"></el-table-column>
                            <el-table-column min-width="100" label="查看材料">
                                <template slot-scope="scope">
                                    <el-button
                                        size="small"
                                        style="color: #194abe"
                                        @click="getapply(scope.row)">
                                        查看材料
                                    </el-button>
                                </template>
                            </el-table-column>
                            <el-table-column min-width="180" label="是否同意">
                            <template slot-scope="scope">
                                <el-button  
                                           size="mini"
                                           type="success"
                                           icon="el-icon-check"
                                           @click="handlecEdit(scope.$index, scope.row)">
                                    通过
                                </el-button>
                                <el-button 
                                           size="mini"
                                           style="color: red"
                                           icon="el-icon-close"
                                           @click="handlecDelete(scope.$index, scope.row)">
                                    打回
                                </el-button>
                            </template>
                        </el-table-column>
                        
                        </el-table>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane label="未通过" name="second">
                    <el-form ref="ruleForm">
                        <el-table
                            :data="formlist"
                            :header-cell-style="{ background: '#FEF8EF', color: '#7C828A' }"
                            style="width: 100%; margin-top: 30px">
                            <el-table-column
                                prop="id"
                                label="编号"
                                min-width="60"></el-table-column>
                            <el-table-column show-overflow-tooltip
                                             prop="name"
                                             label="姓名"
                                             min-width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip
                                             prop="batch"
                                             label="批次"
                                             min-width="100"></el-table-column>
                                             
                            <!--<el-table-column show-overflow-tooltip-->
                            <!--                 prop="major_type"-->
                            <!--                 label="工程类别"></el-table-column>-->
                            <!--<el-table-column show-overflow-tooltip-->
                            <!--                 prop="application_major"-->
                            <!--                 label="申报专业"></el-table-column>-->
                            <el-table-column show-overflow-tooltip
                                             prop="work_jobs"
                                             label="工作范围"  min-width="140"></el-table-column>
                            <el-table-column
                                prop="created_at"
                                label="申报时间"
                                min-width="80"></el-table-column>
                             <el-table-column min-width="100" label="查看材料">
                                <template slot-scope="scope">
                                    <el-button
                                        size="small"
                                        style="color: #194abe"
                                        @click="getapply(scope.row)">
                                        查看材料
                                    </el-button>
                                </template>
                            </el-table-column>
                            <el-table-column min-width="100" label="审核结果">
                                <template slot-scope="scope">
                                    <el-button
                                        round
                                        size="small"
                                        style="color: #fff"
                                        :type="
                                            scope.row.eproject_log_expert_info.status == 1
                                                ? 'success'
                                                : 'danger'
                                        "
                                        :icon="
                                            scope.row.eproject_log_expert_info.status == 1
                                                ? 'el-icon-check'
                                                : 'el-icon-close'
                                        ">
                                        {{
                                            scope.row.eproject_log_expert_info.status == 1
                                                ? "通过"
                                                : "否决"
                                        }}
                                    </el-button>
                                </template>
                            </el-table-column>

                            <el-table-column min-width="100" label="查看">
                                <template slot-scope="scope">
                                    <el-button
                                        size="mini"
                                        @click="handleEdit(scope.$index, scope.row,0)">
                                        评审意见
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane label="已通过" name="third">
                    <el-form ref="ruleForm">
                        <el-table
                            :data="formlist"
                            :header-cell-style="{ background: '#FEF8EF', color: '#7C828A' }"
                            style="width: 100%; margin-top: 30px">
                            <el-table-column
                                prop="id"
                                label="编号"
                                min-width="60"></el-table-column>
                            <el-table-column show-overflow-tooltip
                                             prop="name"
                                             label="姓名"
                                             min-width="100"></el-table-column>
                             <el-table-column show-overflow-tooltip
                                             prop="batch"
                                             label="批次"
                                             min-width="100"></el-table-column>
                                             
                            <el-table-column show-overflow-tooltip
                                             prop="major_type"
                                             label="工程类别"></el-table-column>
                            <!--<el-table-column show-overflow-tooltip-->
                            <!--                 prop="application_major"-->
                            <!--                 label="申报专业"></el-table-column>-->
                            <!--<el-table-column show-overflow-tooltip-->
                            <!--                 prop="work_jobs"-->
                            <!--                 label="工作范围"  min-width="140"></el-table-column>-->
                            <el-table-column
                                prop="created_at"
                                label="申报时间"
                                min-width="80"></el-table-column>
                            <el-table-column min-width="100" label="查看材料">
                                <template slot-scope="scope">
                                    <el-button
                                        size="small"
                                        style="color: #194abe"
                                        @click="getapply(scope.row)">
                                        查看材料
                                    </el-button>
                                </template>
                            </el-table-column>
                            <el-table-column min-width="100" label="审核结果">
                                <template slot-scope="scope">
                                    <el-button
                                        round
                                        size="small"
                                        style="color: #fff"
                                        :type="
                                            scope.row.eproject_log_expert_info.status == 1
                                                ? 'success'
                                                : 'danger'
                                        "
                                        :icon="
                                            scope.row.eproject_log_expert_info.status == 1
                                                ? 'el-icon-check'
                                                : 'el-icon-close'
                                        ">
                                        {{
                                            scope.row.eproject_log_expert_info.status == 1
                                                ? "通过"
                                                : "否决"
                                        }}
                                    </el-button>
                                </template>
                            </el-table-column>

                            <el-table-column min-width="100" label="查看">
                                <template slot-scope="scope">
                                    <el-button
                                        size="mini"
                                        @click="handleEdit(scope.$index, scope.row,0)">
                                        评审意见
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-form>
                </el-tab-pane>
            </el-tabs>

            <el-dialog title="填写不通过原因" :visible.sync="cdialogVisible" width="774px" :before-close="handleClose">
                <div class="yellow-box">
                    <span>{{ user.legal_representative_id }}</span>
                    <span>{{ user.name }}</span>
                    <span v-if="user.created_at">申请提交于{{ user.created_at.slice(0, 10) }}</span>
                </div>
                <p class="Failcontent">{{ content }}</p>
            </el-dialog>
            <el-dialog title="填写意见" :visible.sync="cdialogVisible" width="774px" :before-close="handleClose">
                <div class="yellow-box">
                    <span>{{ user.legal_representative_id }}</span>
                    <span>{{ user.name }}</span>
                    <span v-if="user.created_at">申请提交于{{ user.created_at.slice(0, 10) }}</span>
                </div>
                <textarea id="" v-model="reason" class="reason" name="" cols="30" rows="10" placeholder="点击输入意见..."></textarea>
                <span slot="footer" class="dialog-footer" v-if="showsubmit == 1">
                    <el-button
                        type="primary"
                        icon="el-icon-check"
                        @click="sumbit">确认提交</el-button>
                </span>
            </el-dialog>
            
            <pagetion :total="total" class="pos-page" @getpageValue="getpageValue"></pagetion>
        </div>

    </div>
</template>

<script>
import AllHeader from '@/components/Modal/AllHeader'
import Pagetion from '@/components/Modal/Pagetion'
import {
    eprojectverify,
    eprojectverifyLogs,
    EprojectInfo, //申报记录详情
    EprojectLog, //申报奖项
    EprojectBatches
} from '../utils/api.js'
export default {
    components: {
        AllHeader,
        Pagetion
    },
    data() {
        return {
            content:'',//不通过原因
            dialogVisible:false,//不通过弹框
            user:{},
            isIndex:0,
            activeName: 'first',
            step: 0,
            ischage: false,
            lable: '',
            pageSize: 100,
            total: 0,
            projectList: [],
            sublabel: '返回列表',
            subtitle: '', //副标题
            formlist: [],
            prizeid: '',//奖项id
            keyword:'',//搜索
            activeAward: {},
            activeRow: {},
            loading: false,
            project_batches:[],
            project_batch_id:0,
            cdialogVisible:false,
            cstatus:2,
            showsubmit:1
        }
    },

    mounted() {
        this.lable = this.$route.query.name
        this.token = 'Bearer ' + localStorage.getItem('TOKEN')
        this.initList(1)
    },
    methods: {
        async initList(page) {
            
            
            
            this.project_batches = await EprojectBatches();
            for(var i = 0; i < this.project_batches.length; i ++){
                this.project_batches[i]['year'] = this.project_batches[i]['eproject']['title']+'-'+this.project_batches[i]['year']+'-'+this.project_batches[i]['batch']
            }
            this.project_batch_id = this.project_batches[0] != undefined ? this.project_batches[0]['id'] : '';
            const data = {
                page_size: this.pageSize,
                page: page,
                project_batch_id:this.project_batch_id
            }
            this.getexpertverifyLogs(data);
            
        },
        getvalue() {
            this.step = 0
            this.ischage = false
            this.lable = this.$route.query.name
            this.subtitle = ''
        },
        //搜索
        serch(){
            let data
            this.keyword = this.keyword.toString()
            if (this.isIndex != 0) {
                data = {
                    status: this.isIndex - 1,
                    keyword:this.keyword,
                    project_batch_id:this.project_batch_id
                }
            }else{
                data = {
                    keyword:this.keyword,
                    project_batch_id:this.project_batch_id
                }
            }
            this.getexpertverifyLogs(data)
        },
        getexpertverifyLogs(data){
            this.loading = true
            
            eprojectverifyLogs( data).then((res) => {
                console.log('res',res)
                this.formlist = res.data == undefined ? res :  res.data;
                this.formlist.forEach((e) => {
                    e.created_at = e.created_at.slice(0, 10)
                })
            }).finally(() => {
                this.loading = false
            })
        },
        
        
        //通过
        handlecEdit(a,b) {
            this.cdialogVisible = true
            this.user = b.user
            this.id = b.id
            this.content = b.eproject_log_expert_info.content
            this.cstatus = 1;
            // console.log(a,b)
            // let data = {
            //     status:1
            // }
            // eprojectverify(data,b.id).then(res => {
            //     this.$message({
            //         message: '审核成功',
            //         type: 'success'
            //     })
            //     const data = {
            //         page_size: this.pageSize,
            //         page: 1,
            //     }
            //      this.getexpertverifyLogs(data);
            //     //this.$router.go(-1)
            // }).catch(error => {
            //     this.$message({
            //         message: error,
            //         type: 'warning'
            //     })
            // })
        },
        //立即提交
        sumbit(){
            if (this.reason=='') {
                this.$message.error('请填写意见')
                return false
            }
            let data = {
                status:this.cstatus,
                content:this.reason
            }
            eprojectverify(data,this.id).then(res => {
                console.log(996,res)
                this.$message({
                    message: '提交成功',
                    type: 'success'
                })
                var sdata = {}
                if (this.isIndex != 0) {
                    sdata = {
                        page_size: this.pageSize,
                        page: 1,
                        project_batch_id:this.project_batch_id,
                        keyword:this.keyword,
                        status: this.isIndex - 1,
                    }
                }else{
                    sdata = {
                        page_size: this.pageSize,
                        page: 1,
                        project_batch_id:this.project_batch_id,
                        keyword:this.keyword
                    }
                }
                console.log('sdata',sdata)
                 this.getexpertverifyLogs(sdata);
            }).catch(error => {
                this.$message({
                    message: error,
                    type: 'warning'
                })
            })
            this.cdialogVisible = false
        },
        //不予通过
        handlecDelete(a,b) {
            this.cdialogVisible = true
            this.user = b.user
            this.id = b.id
            this.cstatus = 0;
        },
        
        handleEdit(a,b,show=1) {
            console.log(a,b)
            this.cdialogVisible = true
            this.user = b.user
            this.user.created_at = b.user.created_at.slice(0, 10)
            this.id = b.id
            this.content = b.eproject_log_expert_info.content
            this.reason = b.eproject_log_expert_info.content;// b.reject_reason == null ? '' : b.reject_reason;
            this.showsubmit = show;
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then((_) => {
                    done()
                })
                .catch((_) => {})
        },
        handleDelete() {},
        handleClick(e) {
            let data
            this.isIndex = e.index
            if (e.index != 0) {
                data = {
                    status: e.index - 1,
                    project_batch_id:this.project_batch_id
                }
            } else {
                data = {
                    status: 2,
                    project_batch_id:this.project_batch_id
                }
            }
            this.getexpertverifyLogs(data)
        },
        getpageValue(){

        },
        handleGiveAMarkSuccess() {
            this.step = '1'
            this.onApplyTap(this.activeRow)
        },
        getapply(obj) {
            const resolve = this.$router.resolve(`/word_eproject?title=${this.subtitle}&id=${obj.id}&states=审核&no_back=1&nav_title=申请专家`)
            window.open(resolve.href, '_blank')
        },
        
    }
}
</script>

<style>
.el-tabs__nav-scroll {
  justify-content: flex-start !important;
}
.el-tabs__header {
  width: 40%;
}
</style>
<style lang="less" scoped>
/deep/.block-title {
  border-left: 3px solid #194abe !important;
}
.yellow-box{
    height: 40px;
    background: #FEF8EF;
    opacity: 1;
    border-radius: 6px 6px 0px 0px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    span{
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 24px;
        &:nth-child(1){
            color: #194ABE;
        }
        &:nth-child(2){
            color: #0C0D0F;
        }
        &:nth-child(3){
            color: #7C828A;
            font-size: 14px;
        }
    }
}
.reason{
    margin-top: 20px;
    width: 100%;
    height: 162px;
    background: #FFFFFF;
    border: 1px solid #BDC3CB;
    opacity: 1;
    border-radius: 4px;
    outline: none;
    padding: 10px;
    box-sizing: border-box;
}
.Failcontent {
  display: block;
  width: 100%;
  text-align: start;
  // height: 92px;
  background: #ffffff;
  opacity: 1;
  border-radius: 4px;
  padding: 20px 10px;
  box-sizing: border-box;
}
.right_serch {
  position: absolute;
  right: 30px;
  top: 90px;
  width: 234px;
  height: 33px;
  background: #ffffff;
  border: 1px solid #c8cdd5;
  opacity: 1;
  border-radius: 6px;
  padding-left: 10px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: start;
  input {
    width: 164px;
    height: 19px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 19px;
    color: #c8cdd5;
    outline: none;
    border: none;
  }
  img {
    margin-left: 30px;
  }
}
.textarea {
  width: 382px;
  // height: 92px;
  background: #ffffff;
  border: 1px solid #bdc3cb;
  opacity: 1;
  border-radius: 4px;
}

.block-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 20px 0;

  &-item {
    width: 370px;
    background: #ffffff;
    border: 1px dashed #c8cdd5;
    padding: 24px 25px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 21px;
    position: relative;
    &-r-t {
      position: absolute;
      top: 0;
      right: 0;
      width: 73px;
      height: 27px;
      background: #f5f9fb;
      opacity: 1;
      border-radius: 0px 0px 0px 80px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 27px;
      color: #c6c9ce;
      padding-left: 10px;
      box-sizing: border-box;
    }
    &-box {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: flex-start;
      &-t {
        width: 244px;
        color: #0c0d0f;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-align: justify;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
      }
      &-dtae {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        line-height: 26px;
        color: #194abe;
      }
      &-startend {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 26px;
        color: #7c828a;
      }
      &-b {
        width: 91px;
        height: 32px;
        background: #ffffff;
        border: 1px solid #194abe;
        color: #194abe;
        opacity: 1;
        border-radius: 6px;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        cursor: pointer;
      }

      &-b-d {
        background: #ffffff !important;
        border: 1px solid #d4dbdd !important;
        color: #c8cdd5 !important;
      }

      &-b-s {
        background: #d4dbdd !important;
        border: 1px solid #d4dbdd !important;
        color: #ffffff !important;
      }
    }
  }
}

.margin-bottom-40 {
  margin-bottom: 40px;
}

.infor {
  padding-bottom: 40px;
  min-height: 800px;
  margin-bottom: 34px;
  position: relative;
}

.upload-demo {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.uploadheader {
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;

  span {
    margin-right: 10px;
    color: #71767c;
  }
}

.margin-top-40 {
  margin-top: 40px;
}

.block-solid {
  width: 100%;
  height: 2px;
  background-color: #e51725;
  margin-top: 30px;
}

.shenhjrkr {
  margin: 71px 0 100px 0;

  img {
    width: 120px;
  }
}

.stepContainer {
  width: 100%;
  height: 160px;
  background-color: #f6f6f6;
  margin: 20px 0;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  overflow: hidden;

  .stepcone {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    .stepItem {
      width: 50px;
      height: 50px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background-color: #9fa5ae;
      border: 1px solid #9fa5ae;
      font-size: 32px;
      font-weight: 900;
      color: #c8cdd5;
      z-index: 999;

      .downpng {
        position: absolute;
        top: -20px;
        width: 20px;
        height: auto;
      }
    }

    img {
      width: 27px;
      height: auto;
    }

    .isactibe {
      color: white;
      // border: 1px solid #9FA5AE;
      // background-color: #9FA5AE;
    }

    .stponce {
      color: #194abe;
      border: 1px solid #194abe;
      background-color: white;
    }

    .error {
      color: #e51725;
      border: 1px solid #e51725;
      background-color: white;
    }

    .stepTitle {
      font-size: 18px;
      color: #c8cdd5;
      margin-top: 10px;
    }

    .successtitle {
      color: #0c0d0f;
    }

    .stpotitle {
      color: #194abe;
    }

    .erroritem {
      color: #e51725;
    }

    .line {
      width: 350%;
      flex: 1;
      flex-shrink: 0;
      height: 2px;
      border-bottom: 1px dashed #d4dbdd;
      position: absolute;
      top: 25px;
      left: 85%;
    }
  }
}
.block-addr {
  display: inline-block;
  padding: 13px 32px;
  background-color: #fff7e8;
  font-size: 14px;
  margin-top: 31px;
  .span-l {
    color: #9fa5ae;
  }
  .span-r {
    color: #194abe;
  }
}
.award_batch {
    position: absolute;
    right: 290px;
    top: 90px;
    height: 33px;
    line-height: 33px;
}
.el-input input {
    height: 35px !important;
    line-height: 35px !important;
}
</style>
